






import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'LinkItem',
  props: {
    type: String,
    link: String,
    name: String,
    filename: String,
  },
})
